<user-navigation></user-navigation>

<div class="container-fluid">
    <div class="row no-gutter">
      <div id="top"></div>
        <div class="col-md-12 col-lg-4 profile-side-bar">
            <div class="default-box long-form d-flex align-items-center" style="min-height: 0vh;">
                <div class="container">
                    <div class="row" *ngIf="user">
                        <div class="col-md-12 mb-5 mb-md-0">
                            <div id="page-redirection">
                                <a routerLink="/user/profile">
                                    <img src="../../../../assets/images/arrows/back_arrow.png">
                                    Back to Account
                                </a>
                            </div>
                            <h3 class="display-4 box-title mt-4 mt-md-4">Edit Profile</h3> <br>

                            <img [src]="imageSourcePreview" *ngIf="imageSourcePreview !== ''; else defaultAvatar" class="mb-md-4 mb-4 mt-md-3 mt-3 rounded-circle avatar-big">
                            <ng-template #defaultAvatar>
                                <img [src]="user?.avatar" *ngIf="user.avatar !== ''; else noAvatar" class="mb-md-4 mb-4 mt-md-3 mt-3 rounded-circle avatar-big">
                                <ng-template #noAvatar>
                                    <img src="../../../../assets/images/avatars/default_profile@2x.png" class="mb-md-4 mb-4 mt-md-3 mt-3 rounded-circle avatar-big">
                                </ng-template>
                            </ng-template>

                            <form [formGroup]="editForm" (ngSubmit)="onSubmit()">
                                <label for="imageFileInput" id="imageFileInputLabel">{{ imageUploadLabel }}</label><br>
                                <button
                                    class="btn btn-sm btn-danger btnDeleteUpload"
                                    (click)="deleteUpload()"
                                    *ngIf="imageSourcePreview !== ''"
                                    type="button"
                                >
                                    <i class="fa fa-trash"></i> Delete Upload
                                </button>
                                <input
                                    accept=".jpg, .png, .jpeg, .gif|image/*"
                                    type="file"
                                    class="ml-md-3 ml-3 file-input"
                                    #fileInput
                                    id="imageFileInput"
                                    (change)="onImageFileInputChange($event)"
                                >

                                <!-- Success Message -->
                                <div class="alert alert-success alert-dismissible fade show" role="alert" *ngIf="success">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="success = !success">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                    Details was successfully updated
                                </div>

                                <div class="md-input">
                                    <input
                                        class="md-form-control"
                                        required
                                        type="text"
                                        formControlName="firstName"
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <label>First Name</label>
                                </div>
                                <div class="md-input">
                                    <input
                                        class="md-form-control"
                                        required
                                        type="text"
                                        formControlName="lastName"
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <label>Last Name</label>
                                </div>

                                <button type="submit" class="btn btn-primary btn-block btn-submit">
                                    Save
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-8 d-none d-lg-flex default-box bg-image-user"></div>
    </div>

    <!-- Modal Loader -->
    <modal-loader [modalText]="modalText"></modal-loader>
</div>

<footer-main></footer-main>
